import i18n from "@/i18n/i18n"

export const isLarge: boolean = window.innerWidth > 1024

export const isMobile: boolean = window.innerWidth <= 768

export const isGreek: boolean = i18n.language === 'el'

export const CATEGORY_COLORS = {
    activities: "#890077",
    places: "#00668A",
    events: "#006E0F",
    accomodations: "#704700",
    businesses: "#5600AD",
    Activities: "#890077",
    Places: "#00668A",
    Events: "#006E0F",
    Accomodations: "#704700",
    Accomodation: "#704700",
    Businesses: "#5600AD",
};

